var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forbidden__content"},[_c('div',{staticClass:"panel forbidden__element"},[_c('h2',[_vm._v(_vm._s(_vm.$t("forbidden_message")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }